import PayrollDeductionEditComponents from "../components/PayrollDeductionEdit";
import useDeduction from "../hooks/useDeduction";

const PayrollDeductionEdit = () => {
  const useDeductionProps = useDeduction();
  return <PayrollDeductionEditComponents {...useDeductionProps} />;
};

export default PayrollDeductionEdit;
